import {createRouter, createWebHashHistory, createWebHistory} from 'vue-router';
import noFind from "@/views/noFind.vue";

import {getSource} from "@/http/sys";

const Home = () => import("../views/home/index.vue");

//大客户首页
const BigHome = () => import("../views/home/bigHome.vue");

//公示信息
const PInformation = () => import("../views/publicityInformation/index.vue");
const PublicityInformation = () => import("../views/publicityInformation/pInformation.vue");
//合同模版
const ContractTemplate = () => import("../views/publicityInformation/contractTemplate.vue");
//信息披露
const InformationDisclosure = () => import("../views/publicityInformation/informationDisclosure.vue");
// 投诉受理渠道及流程
const ComplaintAcceptance = () => import("../views/publicityInformation/complaintAcceptance.vue");
//服务价格公示
const servicePricePublicity = () => import("../views/publicityInformation/servicePricePublicity.vue");
//金融知识宣传
const FinancialKnowledge = () => import("../views/publicityInformation/financialKnowledge.vue");

//金融服务
const FinancialServices = () => import("../views/financialService/index.vue");
//金融测算
const FinancialCalculation = () => import("../views/financialService/financialCalculation.vue");
//车贷指南
const CarLoanGuidelines = () => import("../views/financialService/carLoanGuidelines.vue");
//金融产品
const FinancialProducts = () => import("../views/financialService/financialProducts.vue");

//最新活动
const LatestActivity = () => import("../views/latestActivity/index.vue");
//活动1
const Activity1 = () => import("../views/latestActivity/activity.vue");

const Activity2 = () => import("../views/latestActivity/activity2.vue");

//关于我们
const AboutUs = () => import("../views/aboutUs/index.vue");
//公示介绍
const PublicityIntroduction = () => import("../views/aboutUs/publicityIntroduction.vue");
//经销商查询
const DealerQuery = () => import("../views/aboutUs/dealerQuery.vue");
//联系我们
const ContactUs = () => import("../views/aboutUs/contactUs.vue");
//客户留言
const CustomerMessage = () => import("../views/aboutUs/customerMessage.vue");
//隐私政策
const PrivacyPolicy = () => import("../views/aboutUs/privacyPolicy.vue");
//预约贷款
const LoanAppointment = () => import("../views/aboutUs/appointmentLoan.vue");


const routes = [
    {
        path: "/",
        name: Home,
        component: Home,
        meta: {
            title: "首页",
        }
    },
    {
        path: "/bigHome",
        name: BigHome,
        component: BigHome,
        meta: {
            title: "大客户首页"
        }
    },
    {
        path: "/publicityInformation",
        component: PInformation,
        meta: {
            title: "公示信息"
        },
        redirect: to => {
            return {path: 'pInformation'}
        },
        children: [
            {
                path: "pInformation",
                name: '公示信息',
                component: PublicityInformation,
                meta: {
                    title: "公示信息"
                },
            },
            {
                path: "informationDisclosure",
                name: '信息披露',
                component: InformationDisclosure,
                meta: {
                    title: "信息披露"
                },
            },
            {
                path: "contractTemplate",
                name: '合同模板',
                component: ContractTemplate,
                meta: {
                    title: "合同模板"
                },
            },
            {
                path: "complaintAcceptance",
                name: '投诉受理渠道及流程',
                component: ComplaintAcceptance,
                meta: {
                    title: "投诉受理渠道及流程"
                },
            },
            {
                path: "servicePricePublicity",
                name: '服务价格公示',
                component: servicePricePublicity,
                meta: {
                    title: "服务价格公示"
                },
            },
            {
                path: "financialKnowledge",
                name: '金融知识宣传',
                component: FinancialKnowledge,
                meta: {
                    title: "金融知识宣传"
                },
            }
        ]
    },
    {
        path: "/financialServices",
        component: FinancialServices,
        meta: {
            title: "金融服务"
        },
        redirect: to => {
            return {path: 'financialCalculation'}
        },
        children: [
            {
                path: "financialCalculation",
                name: '金融测算',
                component: FinancialCalculation,
                meta: {
                    title: "金融测算"
                },
            }, {
                path: "carLoanGuidelines",
                name: '车贷指南',
                component: CarLoanGuidelines,
                meta: {
                    title: "车贷指南"
                },
            }, {
                path: "financialProducts",
                name: '金融产品',
                component: FinancialProducts,
                meta: {
                    title: "金融产品"
                },
            },
        ]
    },
    {
        path: "/latestActivity",
        component: LatestActivity,
        meta: {
            title: "最新活动"
        },
        redirect: to => {
            return {path: 'activity1'}
        },
        children: [
            {
                path: "activity1",
                name: '活动页1',
                component: Activity1,
                meta: {
                    title: "活动页1"
                },
            },
            {
                path: "activity2",
                name: '活动页2',
                component: Activity2,
                meta: {
                    title: "活动页2"
                },
            },
        ]
    },
    {
        path: "/aboutUs",
        component: AboutUs,
        meta: {
            title: "关于我们"
        },
        redirect: to => {
            return {path: 'publicityIntroduction'}
        },
        children: [
            {
                path: "publicityIntroduction",
                name: '公示介绍',
                component: PublicityIntroduction,
                meta: {
                    title: "公示介绍"
                },
            },
            {
                path: "dealerQuery",
                name: '经销商查询',
                component: DealerQuery,
                meta: {
                    title: "经销商查询"
                },
            },
            {
                path: "contactUs",
                name: '联系我们',
                component: ContactUs,
                meta: {
                    title: "联系我们"
                },
            },
            {
                path: "customerMessage",
                name: '客户留言',
                component: CustomerMessage,
                meta: {
                    title: "客户留言"
                },
            },
            {
                path: "privacyPolicy",
                name: '隐私政策',
                component: PrivacyPolicy,
                meta: {
                    title: "隐私政策"
                },
            },
            {
                path: "loanAppointment",
                name: '预约贷款',
                component: LoanAppointment,
                meta: {
                    title: "预约贷款"
                },
            },
        ]
    },
    {
        path: '/:catchAll(.*)',
        name: '/404',
        component: noFind
    },
]

const router = createRouter({
    history: process.env.NODE_ENV === 'production' ? createWebHistory() : createWebHashHistory(),
    routes,
})

router.beforeEach((to, from, next) => {
    next()
    getSourceFn(to);
})


const getSourceFn = async (to) => {
    console.log(to);
    // 生成一个随机数 类似于uuid
    let userId = "";
    if (localStorage.getItem('userId')) {
        userId = localStorage.getItem('userId')
    } else {
        userId = Math.random().toString(36).substr(2, 10)
    }
    // 存储到localStorage
    localStorage.setItem('userId', userId);


    try {
        const {code, data} = await getSource({
            path: to.path,
            utmSource: to.query?.utmSource || JSON.stringify(to.query),
            userId: userId,
        });

    } catch (e) {
        console.log("getSource err::", e)
    }
}


export default router
